import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarLancamentoTaxasDs, criarTaxasDs } from "../../DataSources";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import memoria from "../../Memoria";
import { imprimirDam, abrirDetalhe } from "../../lancamentosUtils";

const localStorageKey = "cadastroLancamentoTaxasGridState";

export default class LancamentoTaxasBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.state = {
      filtroCorrente: [],
      filtro: { nome: "", inativo: undefined },
    };
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.lancamentoTaxasDs = criarLancamentoTaxasDs();
  }

  filtrar(e) {
    let filtro = this.state.filtro;

    let filtroCorrente = [];

    if (
      filtro.sequencialContribuinte !== undefined &&
      filtro.sequencialContribuinte !== ""
    ) {
      filtroCorrente.push([
        "contribuinte.sequencial",
        "=",
        filtro.sequencialContribuinte.trim(),
      ]);
    }

    if (
      filtro.nomeContribuinte !== undefined &&
      filtro.nomeContribuinte !== ""
    ) {
      filtroCorrente.push([
        "contribuinte.nome",
        "contains",
        filtro.nomeContribuinte.trim(),
      ]);
    }

    if (filtro.taxaId !== undefined && filtro.taxaId !== "") {
      filtroCorrente.push(["taxaId", "=", filtro.taxaId]);
    }

    this._gridInstance.instance.filter(
      filtroCorrente.length > 0 ? filtroCorrente : null
    );
  }

  limparFiltro(e) {
    this.setState({ filtro: {} });
    this.filtrar();
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("lancamentotaxas/editar/" + e.data.sequencial);
  }

  componentDidMount() {
    memoria.redirecionarSeNecessario(this.props.location, this.props.history);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form onSubmit={this.filtrar}>
            <Form
              id="frmPesquisa"
              formData={this.state.filtro}
              colCount={8}
              labelLocation={"top"}
            >
              <SimpleItem dataField="sequencialContribuinte" colSpan={1}>
                <Label text="IMC" />
              </SimpleItem>
              <SimpleItem dataField="nomeContribuinte" colSpan={7}>
                <Label text="Nome/Razão Social" />
              </SimpleItem>
              <SimpleItem
                dataField="taxaId"
                editorType={"dxLookup"}
                editorOptions={{
                  showClearButton: true,
                  dataSource: criarTaxasDs(),
                  valueExpr: "id",
                  displayExpr: "descricao",
                }}
                colSpan={4}
              >
                <Label text="Taxa" />
              </SimpleItem>
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.filtrar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Limpar Filtro" onClick={this.limparFiltro} />
              </div>
            </div>
          </form>
          <br />
          <PaginaToolbar
            titulo="LANÇAMENTOS DIVERSOS"
            novoCb={this.novoRegistro.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.lancamentoTaxasDs}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              focusedRowEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <Editing
                allowDeleting={true}
                allowUpdating={true}
                mode
                useIcons={true}
              />
              <Column type="buttons" fixed={true} fixedPosition={"left"} buttons={
                [{

                  hint: 'DAM',
                  icon: 'money',
                  visible: this.onSelecionado == undefined,
                  onClick: e => imprimirDam(e.row.data)
                },
                  "edit",
                {
                  hint: 'Info. Lançamento',
                  icon: 'more',
                  visible: this.onSelecionado == undefined,
                  onClick: e => abrirDetalhe(this.props.history, e.row.data)
                }, {
                  icon: 'repeat',
                  visible: this.onSelecionado != undefined,
                  onClick: this.onSelecionado
                }]} />
              <Column
                dataField={"id"}
                allowEditing={false}
                visible={false}
                alignment={"center"}
              />
              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column
                dataField={"sequencial"}
                caption={"#"}
                allowEditing={false}
                width={80}
                alignment={"center"}
              />
              <Column
                dataField={"dataLancamento"}
                dataType={"date"}
                caption={"Data"}
                alignment={"right"}
                sortOrder={"desc"}
                sortIndex={1}
              />
              <Column
                dataField={"ano"}
                caption={"Ano"}
                sortIndex={1}
                defaultSortOrder={"desc"}
                width={100}
                alignment={"center"}
              />
              <Column
                dataField={"numeroLancamento"}
                caption={"Número"}
                sortIndex={2}
                defaultSortOrder={"desc"}
                width={100}
                alignment={"center"}
              />
              <Column
                dataField={"contribuinte.sequencial"}
                caption={"IMC"}
                width={80}
                alignment={"center"}
              />
              <Column
                dataField={"contribuinte.nome"}
                caption={"Contribuinte"}
              />
              <Column dataField={"taxa.descricao"} caption={"Taxa"} />
              <Column
                dataField={"valorDoImposto"}
                caption={"Valor"}
                format={{ type: "fixedPoint", precision: 2 }}
              />
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("/lancamentotaxas/novo");
  }
}
